import React from 'react';
import ReactDOM from 'react-dom';
import app from "../Scripts/reducers";
import { composeWithDevTools } from 'redux-devtools-extension/developmentOnly';
import { applyMiddleware, createStore } from 'redux';
import thunk from 'redux-thunk';
import { Provider } from 'react-redux';
import DynamicComponent from '../Scripts/Components/DynamicComponent';
import Navigation from './Components/Navigation/Navigation';
import Search from './Components/Search/Search';
import Language from './Components/Language/Language';

const store = createStore(
    app,
    composeWithDevTools(applyMiddleware(thunk))
);
/*GreatItPageComponents();
GreatItBlockComponents();*/

// Add a dictionary to keep track of the registered async reducers
store.asyncReducers = {};

// Create an inject reducer function
// This function adds the async reducer, and creates a new combined reducer
store.injectReducer = (key, asyncReducer) => {
    if (!store.asyncReducers[key]) {
        store.asyncReducers[key] = asyncReducer;
        store.replaceReducer(createReducer(store.asyncReducers));
    }
};

const registeredContainers = [];
const renderReact = (element, container, callback) => {
    registeredContainers.push(container);
    ReactDOM.render(element, container, callback);
};

export const GreatItComponents = () => {
    //Pages

    if (document.getElementById("exampleReactPage")) {
        const ExampleReactPageComponent = DynamicComponent({
            loader: () => import('../Scripts/Greatit.Cms/Pages/exampleReactPage/ExampleReactPage.container'),
        });
        const pageId = document.getElementById("exampleReactPage").getAttribute("data-page-id");
        ReactDOM.render(
            <Provider store={store}>
                <ExampleReactPageComponent {...{ pageId }} />
            </Provider>,
            document.getElementById('exampleReactPage')
        );
    }

    if (document.getElementById("newsPage")) {
        const NewsPageComponent = DynamicComponent({
            loader: () => import('../Scripts/Greatit.Cms/Pages/newsPage/NewsPage.container'),
        });
        const pageId = document.getElementById("newsPage").getAttribute("data-page-id");
        ReactDOM.render(
            <Provider store={store}>
                <NewsPageComponent {...{ pageId }} />
            </Provider>,
            document.getElementById('newsPage')
        );
    }

    if (document.getElementById("contactPage")) {
        const ContactPageComponent = DynamicComponent({
            loader: () => import('../Scripts/Greatit.Cms/Pages/ContactPage/ContactPage.container'),
        });
        const pageId = document.getElementById("contactPage").getAttribute("data-page-id");
        ReactDOM.render(
            <Provider store={store}>
                <ContactPageComponent {...{ pageId }} />
            </Provider>,
            document.getElementById('contactPage')

        );
    }

    if (document.getElementById("productListPage")) {
        const ProductListPageComponent = DynamicComponent({
            loader: () => import('../Scripts/Greatit.Cms/Pages/productPage/ProductListPage.container'),
        });
        const pageId = document.getElementById("productListPage").getAttribute("data-page-id");
        ReactDOM.render(
            <Provider store={store}>
                <ProductListPageComponent {...{ pageId }} />
            </Provider>,
            document.getElementById('productListPage')
        );
    }
    if (document.getElementById("searchResultPage")) {
        const SearchResultPageComponent = DynamicComponent({
            loader: () => import('../Scripts/Greatit.Cms/Pages/searchPage/SearchPage.container'),
        });
        const pageId = document.getElementById("searchResultPage").getAttribute("data-page-id");
        ReactDOM.render(
            <Provider store={store}>
                <SearchResultPageComponent {...{ pageId }} />
            </Provider>,
            document.getElementById('searchResultPage')
        );
    }
    if (document.getElementById("applicationPage")) {
        const ApplicationPageComponent = DynamicComponent({
            loader: () => import('../Scripts/Greatit.Cms/Pages/applicationPage/ApplicationPage.container'),
        });
        const pageId = document.getElementById("applicationPage").getAttribute("data-page-id");
        ReactDOM.render(
            <Provider store={store}>
                <ApplicationPageComponent {...{ pageId }} />
            </Provider>,
            document.getElementById('applicationPage')
        );
    }
    if (document.getElementById("taxListPage")) {
        const TaxListPageComponent = DynamicComponent({
            loader: () => import('../Scripts/Greatit.Cms/Pages/taxPage/TaxListPage.container'),
        });
        const pageId = document.getElementById("taxListPage").getAttribute("data-page-id");
        ReactDOM.render(
            <Provider store={store}>
                <TaxListPageComponent {...{ pageId }} />
            </Provider>,
            document.getElementById('taxListPage')
        );
    }
    // Components 
    if (document.getElementById('navbar')) {
        renderReact(
            <Provider store={store}>
                <Navigation />
            </Provider>,
            document.getElementById('navbar')
        );
    }

    if (document.getElementById('search')) {
        renderReact(
            <Provider store={store}>
                <Search />
            </Provider>,
            document.getElementById('search')
        );
    }


    if (document.getElementById('language')) {
        renderReact(
            <Provider store={store}>
                <Language />
            </Provider>,
            document.getElementById('language')
        );
    }
}
document.addEventListener("DOMContentLoaded", function (event) {
    GreatItComponents();
});

